import { render, staticRenderFns } from "./writeRemark.vue?vue&type=template&id=e5944294&scoped=true&"
import script from "./writeRemark.vue?vue&type=script&lang=js&"
export * from "./writeRemark.vue?vue&type=script&lang=js&"
import style0 from "./writeRemark.vue?vue&type=style&index=0&id=e5944294&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5944294",
  null
  
)

export default component.exports